export default "<div class=\"footer\">\r\n    <span>© 2020 Copyright <a target=\"_blank\" href=\"http://tfleet.com\">TFleet Management</a></span>\r\n</div>";